import TableOrder from "components/base/TableOrder/TableOrder";

export default TableOrder;
